import React from "react";
import styled from "styled-components/macro";

import WaitForSync from "components/LoadingSpinner/WaitForSync";
import { ApiModel } from "constants/loading";
import { useOpenCreateSaleModal } from "hooks/useOpenCreateSaleModal";
import Button from "./Button";

const AddSaleButton = styled(Button)`
  margin-left: 10px;
  min-height: 2.5rem;
  max-height: 38px;
  min-width: 140px;
`;

const EmptyStateActionButton = styled.button`
  background: transparent;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primaryHighlight};
  font-weight: normal;
  font-size: 14px;
  border: none;
  line-height: 1.5;
  margin: auto 0;
`;

interface AddSaleInEmptyStateProps {
  buttonText: string;
  canCreateSale: boolean;
  useStyledButton: boolean;
}

export const AddSaleInEmptyState = ({
  buttonText,
  canCreateSale,
  useStyledButton,
}: AddSaleInEmptyStateProps): React.JSX.Element => {
  const openCreateSaleModal = useOpenCreateSaleModal();

  if (!canCreateSale) {
    return null;
  }

  const ButtonComponent = useStyledButton
    ? AddSaleButton
    : EmptyStateActionButton;

  return (
    <WaitForSync
      requiredData={[
        ApiModel.ROUNDS,
        ApiModel.SPECIES,
        ApiModel.DEPLOYMENTS,
        ApiModel.SALE_DEFINITIONS,
        ApiModel.AGENCIES,
      ]}
    >
      <ButtonComponent onClick={openCreateSaleModal} data-tour="addSale">
        {buttonText}
      </ButtonComponent>
    </WaitForSync>
  );
};
